import React from 'react'
import ScanRewardsTable from './Table'

const ScanRewards = (props) => {
  return <ScanRewardsTable {...props} />
}

export default ScanRewards
